import { MAP_DEFAULT_VALUES, ZONE_COLORS } from '../../helpers/constants';

export default {
  geoRadarZone: {
    isAddOpen: false,
    isEditOpen: false,
    isVersionEditOpen: false,
    zoneColor: ZONE_COLORS[0],
    zoneOpacity: 0.5,
    selectedZoneItem: null,
    selectedVersionZoneItem: null,
    selectedVersionRows: null,
    activeExpZoneRow: [],
    pathsOfPolygon: [],
    editPathOfPolygon: [],
    versionEditPathsOfPolygon: [],
    locationLat: MAP_DEFAULT_VALUES.LAT,
    locationLon: MAP_DEFAULT_VALUES.LNG,
    drawnPolygonPaths: [],
    isFiltersOpen: false,
    heatmapToggle: false,
    heatmapDateRange: null,
    nearbyZones: [],
  },
  rivalsByLocation: {
    showCleanAndResetButton: false,
    rivalsByLocationMarkers: [],
    rivalsByLocationLatAndLngValue: null,
    selectedRivalsMarker: null,
    getRivalsByLocationButtonChangeTitle: false,
  },
  cityDistrictAndNeighborhoodSelection: {
    storeLocationsLatLng: [],
    selectedCity: false,
    selectedDistrict: false,
    selectedNeighborhood: false,
  },
  selectedStoreAndRegionFromStore: {
    selectedRegion: [],
    selectedStore: [],
    storesOfRegions: [],
  },
  slotsFromZone: {
    store: {},
    zonesOfStore: [],
    zone: {},
  },
};
